import React from 'react';
import cn from 'classnames';
import { AuthContext } from 'auth';
import { generatePath } from 'utils/generatePath';
import { LockIcon } from 'components/icons';
import { SidebarProps } from './types';

export function DesktopSidebar(props: SidebarProps): React.ReactElement {
  const { items, getItemProps, classes, header, footer } = props;
  const { currentUser: user } = React.useContext(AuthContext);

  return (
    <div
      className={cn(
        classes.background,
        'sidebar-desktop odin-hidden xl:odin-flex xl:odin-flex-col',
      )}
    >
      <div
        className={cn(
          'odin-flex odin-grow',
          'odin-flex-col',
          'odin-pt-5',
          'odin-pb-4',
          'odin-px-6',
          'odin-overflow-y-auto',
        )}
      >
        <div className={classes.header('desktop')}>{header}</div>
        <nav className="odin-mt-5 odin-flex-1 odin-space-y-1">
          {items.map((item): React.ReactElement => {
            if (!item.acl || user.hasAnyRole(item.acl)) {
              const { isLocked, isActive, openInNewTabProps } =
                getItemProps(item);
              const { link: Link, icon: Icon, status } = item;
              const {
                text: statusText,
                color: statusColor,
                icon: StatusIcon,
              } = status ?? {};

              return (
                <Link
                  key={item.path}
                  to={generatePath(item.path, {})}
                  className={cn(
                    classes.item(isActive, 'desktop'),
                    'odin-p-3 odin-text-base',
                  )}
                  {...openInNewTabProps}
                >
                  <div className="odin-flex odin-items-center odin-gap-x-3">
                    {Icon && (
                      <Icon
                        className={cn(
                          classes.icon(isActive, 'desktop'),
                          'odin-text-lg odin-h-5 odin-w-6 odin-shrink-0',
                        )}
                      />
                    )}
                    <span className="odin-whitespace-nowrap">{item.text}</span>
                    {isLocked && <LockIcon />}
                  </div>
                  {statusText && (
                    <div
                      className={cn(
                        statusColor,
                        'odin-flex odin-items-center odin-mt-2 odin-gap-x-2',
                      )}
                    >
                      {StatusIcon && <StatusIcon />} {statusText}
                    </div>
                  )}
                </Link>
              );
            }
            return null;
          })}
        </nav>
      </div>
      <div className={classes.footer('desktop')}>{footer}</div>
    </div>
  );
}
